import styles from './Sorter.module.scss';

import { Header } from '@tanstack/react-table';
import React, { useCallback, useEffect, useRef } from 'react';

import { ReactComponent as DownIcon } from '@work4all/assets/icons/arrow_drop_down.svg';
import { ReactComponent as UpIcon } from '@work4all/assets/icons/arrow_drop_up.svg';

import { Truncation } from '../../../../../../components/tooltip/Tooltip';
import { ColumnAdditionalData } from '../../../../types';

interface SorterV8Props extends Truncation {
  children?: React.ReactNode;
  column: Header<ColumnAdditionalData, unknown>;
}

export const SorterV8: React.FC<SorterV8Props> = (_props) => {
  const { onTruncation, ...props } = _props;

  const childRef = useRef<HTMLDivElement>(null);

  const isElementTruncated = useCallback((element: HTMLElement): boolean => {
    const hasEllipsis =
      element.scrollWidth > element.clientWidth ||
      element.scrollHeight > element.clientHeight;
    if (hasEllipsis) return true;
    return false;
  }, []);

  useEffect(() => {
    if (childRef.current) {
      onTruncation(isElementTruncated(childRef.current));
    }
  }, [isElementTruncated, onTruncation]);

  const sortOrder = props.column.column.getIsSorted();

  function renderSortIcon() {
    if (!sortOrder) return null;
    const Icon = sortOrder === 'asc' ? UpIcon : DownIcon;
    return <Icon className={styles.icon} />;
  }

  return (
    <div
      className={styles.sorter}
      onClick={props.column.column.getToggleSortingHandler()}
      style={{
        cursor: props.column.column.getCanSort() ? 'pointer' : 'default',
      }}
    >
      {renderSortIcon()}
      <div ref={childRef} className={styles.content}>
        {props.children}
      </div>
    </div>
  );
};
